import { render, staticRenderFns } from "./QuoteForm.vue?vue&type=template&id=96787820"
import script from "./QuoteForm.vue?vue&type=script&lang=ts"
export * from "./QuoteForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports